import React, { useState, useEffect } from "react";
import { Form, Input, Button, Row, Col, message, Select, Modal } from "antd";
import userApi, { UserMobilePostBody, Country, MobileExistPostBody } from "../../services/userApi";
import Spinner from '../../components/custom/Spinner';

const MobileOTPByPassPage: React.FC = () => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const [countries, setCountries] = useState<Country[]>([]);
  const [filtered, setFiltered] = useState<Country[]>([]);
  const [loadingCountries, setLoadingCountries] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isMobileUpdateModalVisible, setIsMobileUpdateModalVisible] = useState(false);
  const [oldMobile, setOldMobile] = useState<string | null>(null);
  const [newMobile, setNewMobile] = useState<string | null>(null);
  const [emailControl, setEmailControl] = useState<string | null>(null);

 const normalizeIsd = (isd?: string) => {
  if (!isd) return "";
  const trimmed = isd.trim();
  return trimmed.startsWith("+") ? trimmed : `+${trimmed}`;
};


const searchCountry = (list: Country[], text: string) => {
  const q = text.trim().toLowerCase();
  if (!q) return list;

  const exact = list.filter((x) => x.name.trim().toLowerCase() === q);
  const starts = list.filter(
    (x) =>
      x.name.trim().toLowerCase().startsWith(q) &&
      x.name.trim().toLowerCase() !== q
  );
  const contains = list.filter(
    (x) =>
      x.name.trim().toLowerCase().includes(q) &&
      !x.name.trim().toLowerCase().startsWith(q)
  );

  // Combine but remove duplicates if any
  const combined = [...exact, ...starts, ...contains];
  const seen = new Set<string>();
  return combined.filter((c) => {
    if (seen.has(c.id)) return false;
    seen.add(c.id);
    return true;
  });
};

  const loadCountries = async () => {
    try {
      setLoadingCountries(true);
      const result = await userApi.getCountries();
      setCountries(result);
      setFiltered(result);
    } catch (error) {
      console.log("Error loading countries:", error);
    } finally {
      setLoadingCountries(false);
    }
  };

  const handleSubmitOk = () => {
    setIsMobileUpdateModalVisible(false);

    updateMobileNumber(form.getFieldsValue());
  };

  const handleSubmitCancel = () => {
    setIsMobileUpdateModalVisible(false);
  };

  useEffect(() => {
    loadCountries();
  }, []);

  const IsMobileNumberExist = async (mobileNumber: string, emailId : string) => {

     const mobileInfoExist: MobileExistPostBody = {
            emailID: emailId,
            mobileNo: mobileNumber,
        }; 
        const mobileExist = await userApi.isUserMobileExist(mobileInfoExist);
        return mobileExist;
  };

  const updateMobileNumber = async (values: any) => {

    try {
      setIsSubmitting(true);

      const selectedCountry = countries.find((c) => c.id === values.countryCode);
      const isd = normalizeIsd(selectedCountry?.isdCode);
      const isdMobileNumber = `${isd}${values.mobile}`;

      const mobileInfoPost: UserMobilePostBody = {
        emailID: values.email,
        mobileNo: isdMobileNumber
      };

      console.log("Final object:", mobileInfoPost);
      await userApi.postUserMobile(mobileInfoPost);
      messageApi.success("Submitted successfully");

      form.resetFields(["email", "countryCode", "mobile"]);
    }
    catch (err: any) {

      if (err.response.status === 404 || err.response.status === 409) {
        messageApi.error(err.response.data.error);
      }
      else if (err.status === 400) {

        const apiErrors = err?.response?.data?.errors;
        if (apiErrors) {
          // extract the first error message
          const firstKey = Object.keys(apiErrors)[0];
          const firstMessage = apiErrors[firstKey][0];

          messageApi.error(firstMessage);
        }
      }
      else {
        messageApi.error("something went wrong");
      }
      console.log(err);
    }
    finally {
      setIsSubmitting(false);
    }
  };
 
  const onFinish = async (values: any) => {
    try {
      const selectedCountry = countries.find((c) => c.id === values.countryCode);
      const isd = normalizeIsd(selectedCountry?.isdCode);
      const isdMobileNumber = `${isd}${values.mobile}`;
      
      const mobileExists = await IsMobileNumberExist(isdMobileNumber, values.email);

      if (mobileExists.showConfirmBox) {
        setIsMobileUpdateModalVisible(true);
        setOldMobile(mobileExists.existingMobileNo);// mobile from DB
        setNewMobile(isdMobileNumber);// mobile from form
        setEmailControl(values.email);
      } else {
        updateMobileNumber(values);
      }
    }
    catch (err: any) {

      if (err.response.status === 404 || err.response.status === 409) {
        messageApi.error(err.response.data.error);
      }
      else if (err.status === 400) {

        const apiErrors = err?.response?.data?.errors;
        if (apiErrors) {
          // extract the first error message
          const firstKey = Object.keys(apiErrors)[0];
          const firstMessage = apiErrors[firstKey][0];

          messageApi.error(firstMessage);
        }
      }
      else {
        messageApi.error("something went wrong");
      }
      console.log(err);
    }
  };

  return (
    <>
      {contextHolder}

      {/* Modal for user existence confirmation */}
      <Modal
          closable={false}
          footer={null}
          centered
          visible={isMobileUpdateModalVisible}
          bodyStyle={{
            textAlign: "center",
            padding: "24px 16px",
            borderRadius: 12,
          }}
        >
          <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>
            Confirm Update
          </h3>
          <p style={{ fontSize: 14, color: "#555", marginBottom: 24, textAlign: "left" }}>
             Are you sure you want to change the mobile number from
			  <strong> {oldMobile} </strong> to <strong> {newMobile} </strong>
			  for <strong> {emailControl}
			 </strong> ?
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <Button
              type="primary"
              block
              style={{
                backgroundColor: "#41787C",
                borderColor: "#41787C",
                height: 40,
                fontWeight: 500,
              }}
              onClick={() => {
                handleSubmitOk();
              }}
            >
              Yes
            </Button>
            <Button
              block
              style={{
                backgroundColor: "#f2f2f2",
                border: "none",
                color: "#333",
                height: 40,
                fontWeight: 500,
              }}
              onClick={() => {
                handleSubmitCancel();
              }}
            >
              No
            </Button>
          </div>
        </Modal>

      <Form form={form} layout="vertical" onFinish={onFinish} requiredMark={false}>
        <Row gutter={[16, 16]}>
          {/* Email */}
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label={
                <span style={styles.label}>
                  Email ID <span style={{ color: "red" }}>*</span>
                </span>
              }
              name="email"
              rules={[
                { required: true, message: "Email is required" },
                { type: "email", message: "Please enter a valid email" },
              ]}
            >
              <Input placeholder="Enter your email" style={styles.uniformControl} />
            </Form.Item>
          </Col>

          {/* Country Code */}
          <Col xs={24} sm={24} md={12}>
           <Form.Item
            label={
                <span style={styles.label}>
                Country Code <span style={{ color: "red", marginLeft: 4 }}>*</span>
                </span>
            }
            name="countryCode"
            rules={[{ required: true, message: "Please select country code" }]}
            >
            <Select
                placeholder="Select Country Code"
                showSearch
                style={styles.uniformControl}
                loading={loadingCountries}
                filterOption={false} // we use onSearch + filtered state
                onSearch={(text) => {
                if (!text) setFiltered(countries);
                else setFiltered(searchCountry(countries, text));
                }}
                // optional: when user clears search, reset filtered
                onBlur={() => setFiltered(countries)}
            >
                {filtered.map((c) => {
                const isd = normalizeIsd(c.isdCode); // ensures single +
                return (
                    <Select.Option key={c.id} value={c.id}>
                    {`${c.name} (${isd})`}
                    </Select.Option>
                );
                })}
            </Select>
            </Form.Item>
          </Col>

          {/* Mobile */}
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label={
                <span style={styles.label}>
                  Mobile Number <span style={{ color: "red" }}>*</span>
                </span>
              }
              name="mobile"
              rules={[
                { required: true, message: "Mobile number is required" },
                { pattern: /^[0-9]{6,14}$/, message: "Enter digits only (6 to 14 digits)" },
              ]}
            >
              <Input placeholder="Enter mobile number" maxLength={14} />
            </Form.Item>
          </Col>

          {/* Submit */}
          <Col xs={24}>
            <Form.Item style={{ textAlign: "right" }}>
              <Button type="primary" htmlType="submit" style={styles.greenButton}
              disabled={isSubmitting}
              >
                <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  {isSubmitting && <Spinner />}
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </span>
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default MobileOTPByPassPage;

const baseGreen = '#3E767A';
const styles: { [key: string]: React.CSSProperties } = {
label: {
    color: '#3E767A',
    fontSize: '20px',
    marginBottom: '7px',
    fontWeight: 630,
    //textAlign: 'left',
    lineHeight: '24px',
  },
  greenButton :
	{
    padding: "8px 16px",
    fontSize: '13px',
    borderRadius: '20px',
    fontWeight: 600,
    border: `2px solid ${baseGreen}`,
    color: '#F1F2F4',
    cursor: 'pointer',
    //transition: 'all 0.2s ease-in-out',
    backgroundColor: baseGreen,
    //width: '170px',
    //height: '35px',
  },
  uniformControl: {
    height: "40px",
    borderRadius: "6px",
  }
};